
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sbgdaxkzktxlojssxplo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNiZ2RheGt6a3R4bG9qc3N4cGxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY5ODQwNDcsImV4cCI6MjA2MjU2MDA0N30.h-uu4pwNW_V_PX0menSAdlbbXJM_aHvSitdmAz9Yz1c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
